// Module
var code = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.66667 0H0V16H2.66667V0ZM4.66667 8L16 0V16L4.66667 8Z\" fill=\"white\"/> </svg> ";
// Exports
module.exports = code;